import { SCRIPT_BLOCKED_TYPE } from 'constants/elementTypes'

import noop from 'utils/noop'

const isBlockedBySrc = isBlockedBy('src')
const isBlockedByHref = isBlockedBy('href')

const TAG_TESTS = {
  EMBED: isBlockedBySrc,
  IFRAME: isBlockedBySrc,
  IMG: isBlockedBySrc,
  LINK: isBlockedByHref,
  OBJECT: isBlockedBySrc,
  SCRIPT: isScriptBlocked,
}

/**
 * @param {HTMLElement} element
 *
 * @returns {boolean} true if the element bears all the hallmarks of manual blocking
 */
export default function isElementManuallyBlocked(element) {
  // `instanceof Element` is false for an element created in another window,
  // such as a parent frame or an iframe, even after it is inserted here.
  if ( element?.nodeType !== Node.ELEMENT_NODE ) {
    throw new Error('Argument to isElementManuallyBlocked() must be an Element.' +
                    `Got ${ element }`)
  }

  if ( !element.dataset.categories ) {
    return false
  }

  const testElement = TAG_TESTS[element.tagName] || noop

  return testElement(element)
}

function isScriptBlocked(element) {
  return ( element.getAttribute('type') === SCRIPT_BLOCKED_TYPE )
}

function isBlockedBy(attrName) {
  return (element) => {
    return Boolean(element.dataset[attrName] && !element.getAttribute(attrName))
  }
}
